<div>
  <div class="clock">
    <ul class="flip minutePlay">
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">0</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">0</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">1</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">1</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">2</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">2</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">3</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">3</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">4</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">4</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">5</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">5</div>
          </div>
        </a>
      </li>
    </ul>
    <ul class="flip secondPlay">
      <li class="active">
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">0</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">0</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">1</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">1</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">2</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">2</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">3</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">3</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">4</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">4</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">5</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">5</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">6</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">6</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">7</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">7</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">8</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">8</div>
          </div>
        </a>
      </li>
      <li>
        <a href="#">
          <div class="up">
            <div class="shadow"></div>
            <div class="inn">9</div>
          </div>
          <div class="down">
            <div class="shadow"></div>
            <div class="inn">9</div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>
